import "./MatchKeyEventComponents.css";

import { ISoccerMatchMissedPenaltyEvent } from "../../../../../../../types";

export const MissedPenaltyEvent = ({
  event,
  isHomeTeamEvent,
  isAwayTeamEvent,
}: {
  event: ISoccerMatchMissedPenaltyEvent;
  isHomeTeamEvent: boolean;
  isAwayTeamEvent: boolean;
}) => {
  return (
    <div className="match-key-event">
      <span className="home-team-match-key-event">
        {isHomeTeamEvent && (
          <>
            <span className="event-player-name">{event.playerName}</span>
            <img
              src={"/images/match-events/missed-penalty.svg"}
              height={13}
              width={13}
              alt={"missed-penalty"}
              className=""
            />
          </>
        )}
      </span>
      <span className="time-match-key-event">{`${event?.timeMin}'`}</span>
      <span className="away-team-match-key-event">
        {isAwayTeamEvent && (
          <>
            <img
              src={"/images/match-events/missed-penalty.svg"}
              height={13}
              width={13}
              alt={"missed-penalty"}
              className=""
            />
            <span className="event-player-name">{event.playerName}</span>
          </>
        )}
      </span>
    </div>
  );
};
